import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { CatAgreementModel } from 'src/app/model/cat-agreement.model';

@Injectable({
  providedIn: 'root'
})
export class CatAgreementService {
  private url:string;

  ////////////////
  constructor(
    private http:HttpClient
  ) {
    this.url=environment.services_url;
  }

  // catalogo completo (activos e inactivos)
  getAll=()=> {
    return this.http.get(`${this.url}/CatAgreement/List`)
      .pipe(
        map((resp:any)=> resp)
      );
  }

  // catalogo solo activos (id/description) para selectores
  catalog=()=> {
    return this.http.get(`${this.url}/CatAgreement/Catalog`)
      .pipe(
        map((resp:any)=> resp)
      );
  }

  getOne=(agreementId:number)=> {
    return this.http.get(`${this.url}/CatAgreement/${agreementId}`)
      .pipe(
        map((resp:any)=> resp)
      );
  }

  // agreementId es mandante: siempre se envia, nunca se autogenera en el front
  save=(agreement:CatAgreementModel)=> {
    return this.http.post(`${this.url}/CatAgreement/SaveUpdate`, agreement)
      .pipe(
        map((resp:any)=> resp)
      );
  }

  // activar/desactivar explicito
  setActive=(agreementId:number, active:boolean, userId:number)=> {
    return this.http.put(`${this.url}/CatAgreement/${agreementId}/active?active=${active}&userId=${userId}`, {})
      .pipe(
        map((resp:any)=> resp)
      );
  }

  upload=(userName: string, file: File, replace: boolean)=> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('userName', userName);
    formData.append('table', 'agreement');
    formData.append('replace', String(replace));
    formData.append('userId', localStorage.getItem('com_token'));
    return this.http.post(`${this.url}/upload/save`, formData)
      .pipe(
        map((resp:any)=> resp)
      );
  }

  downloadLayout = () => this.http.get(`${this.url}/CatAgreement/DownloadLayout`, { responseType: 'blob' });
}
